import Base from './Base';
import get from 'lodash/get';
import merge from 'lodash/merge';
import every from 'lodash/every';
import isArray from 'lodash/isArray';
import { set } from 'lodash';

const defaults = {
  settings: {
    maxMotivos: 1,
    commentEnabled: false,
    allowScoreNA: false,
    motivesLayout: 'default',
  },
  strings: {
    motivosTitle: 'main-reason-opinion',
    footerMotives: '',
  },
};

const evalCondition = (value, operator, target) => {
  // console.log('score: ', value, operator, 'target: ', target
  if (value === undefined) return undefined;
  if (operator === '=') return value === target;
  if (operator === '<') return value < target;
  if (operator === '>') return value > target;
  if (operator === '<=') return value <= target;
  if (operator === '>=') return value >= target;
  if (operator === '!=') return value !== target;
  if (operator === 'between') return value >= target[0] && value <= target[1];
};

export default class Module extends Base {
  constructor(data) {
    super(data);
    this.metadata = this.metadata || {};
    // RANDOM MOTIVES
    if (get(this, 'metadata.settings.randomMotives', false)) {
      this.motives = this.shuffleArray(this.motives);
    }
  }

  get settings() {
    return merge({}, defaults.settings, this.metadata.settings);
  }

  get strings() {
    return merge(
      {},
      defaults.strings,
      this.poll.metadata.strings,
      this.metadata.strings
    );
  }

  get maxMotivos() {
    return this.settings.maxMotivos;
  }

  get max(){
    let max = 10;
    if(this.score_type==='smiles') max = 4;
    if(this.score_type==='boolean') max = 1;
    return get(this,'settings.score.max',max);
  }

  get min(){
    let min = 1;
    if(this.score_type==='numeric') min = 0;
    if(this.score_type==='boolean') min = 0;
    return get(this,'settings.score.min',min);
  }

  isNotDisable(value) {
    const media = get(this.settings,'media');
    return !media || (media && (!get(media, 'showQuestionAfterVideo', true) || get(value,'played')))
  }

  isBreaker() {
    return get(this.settings, 'break', false);
  }

  hasMotivesAnswered(responses) {
    const response = responses[this.index];
    return get(response, 'motivoSelected', []).length > 0;
  }

  hasMotives() {
    return get(this, 'motives', []).length > 1;
  }

  getNext(responses) {
    const rules = get(this.settings, 'rules', []);
    const response = responses[this.index];
    const nextItem = this.poll.getNextTo(this);

    const nextId = rules.reduce((reduced, { goto, conditions = [] }) => {
      if (reduced !== undefined) return reduced;
      if (!conditions.length) return goto;

      const evaluation = conditions.map((condition) => {
        const { type, value, operator } = condition;

        const min = get(this, 'metadata.settings.score.min', 0);
        const max = get(this, 'metadata.settings.score.max', 10);

        const convertedValue = isArray(value)
          ? [
              ((value[0] - min) * 9) / (max - min) + 1,
              ((value[1] - min) * 9) / (max - min) + 1,
            ]
          : ((value - min) * 9) / (max - min) + 1;

        if (type === 'motives') {
          const evaluated = evalCondition(
            get(response, 'motivoSelected[0].id'),
            operator,
            value
          );
          return evaluated === undefined ? 'NOT_EVALUATED' : evaluated;
        }

        if (type === 'score') {
          const evaluated =
            //  evalCondition(response.score, operator, value);

            (() => {
              if (get(this, 'score_type') === 'numeric') {
                return evalCondition(
                  get(response,'score'),
                  operator,
                  value != null ? convertedValue : value
                );
              }
              return evalCondition(get(response,'score'), operator, value);
            })();

          return evaluated === undefined ? 'NOT_EVALUATED' : evaluated;
        }
        return true;
      });
      if (evaluation.includes('NOT_EVALUATED')) return 'NOT_EVALUATED';
      return every(evaluation) ? goto : undefined;
    }, undefined);

    if (nextItem && !get(this, 'settings.required',true) && get(nextItem, 'type') !== 'thanks' && nextId!=='end') {
      let auxNextItem = nextItem;
      if(nextId){
        auxNextItem = this.poll.sortedQuestions.find((item) =>
          item.matchId ? item.matchId(nextId) : item.id === nextId
        );
      }
      const item = auxNextItem?auxNextItem:nextItem;

      if (
        !get(response, 'score', false) &&
        get(this, 'score_type', null) !== null
      ) {
        return {
          nextItem: item,
        };
      }
      if (
        get(response, 'motivoSelected', []).length > 0 &&
        get(this, 'score_type', null) === null
      ) {
        return {
          nextItem: item,
        };
      }
    }

    /*  nextId
      #: goto #
      undefined: None conditions met
      null: Not evaluated
    */
    if (nextId === 'NOT_EVALUATED')
      return {
        error: 'NOT_EVALUATED',
        blocked: true,
      };

    if (nextId === 'end')
      return {
        error: 'END',
        isLast: true,
      };

    if (nextId !== undefined) {
      const nextItem = this.poll.sortedQuestions.find((item) =>
        item.matchId ? item.matchId(nextId) : item.id === nextId
      );
      if (!nextItem) {
        console.log('smile-error: question id not found');
      } else if (nextItem.type === 'thanks') {
        const thanks = get(nextItem, 'metadata.thanks');
        set(thanks, 'redes', get(nextItem, 'metadata.redes'));
        return {
          error: 'END',
          isLast: true,
          thanks: thanks,
        };
      }
      return {
        nextItem,
      };
    }

    if (!nextItem) {
      return {
        error: 'END',
        isLast: true,
      };
    } else if (nextItem.type === 'thanks') {
      return {
        error: 'END',
        isLast: true,
      };
    }

    return {
      nextItem: nextItem,
    };
  }

  getErrors(values) {
    const response = values[this.index];
    const errors = [];

    if (!response) return [new Error('Invalid value.')];

    const motiveCondition = get(this, 'motives', []).length > 1 && ((get(this,'type','question') === 'question' && (get(response,'score') && get(response,'dirty') && get(this,'score_type',null)!==null) || (get(this,'score_type',null)===null)))
    // Si es una pregunta no obligatoria salteo los demas chequeos, no pusheo errores
    if (!get(this, 'metadata.settings.required', true)) {
      return errors;
    }

    if(this.type === 'attachment' && !response.src) {
      errors.push(
        Object.assign(new Error('Invalid file'), {
          target: 'attachment',
        })
      )
    }

    if (this.score_type === 'smiles' && response.voto === undefined)
      errors.push(
        Object.assign(new Error('Invalid score'), {
          target: 'score',
        })
      );
    if (this.score_type && response.score === undefined && this.type === 'question')
      errors.push(
        Object.assign(new Error('Invalid score'), {
          target: 'score',
        })
      );
    if (!this.score_type && this.settings.commentEnabled && !response.comment)
      errors.push(
        Object.assign(new Error('Invalid comment'), {
          target: 'comment',
        })
      );
    if (
      get(response, 'motivoSelected', []).length === 0 &&
      motiveCondition &&
      !this.settings.commentEnabled
    )
      errors.push(
        Object.assign(new Error('Invalid motives'), {
          target: 'motive',
        })
      );
    if ((get(response, 'motivoSelected', []).length < this.settings.minMotivos) && motiveCondition)
      errors.push(
        Object.assign(new Error('Invalid min motives'), {
          target: 'motive',
        })
      );

    if(this.type==='store' && !get(response,'store_key')) errors.push(
      Object.assign(new Error('Store is required'), {
        target: 'store',
      })
    );

    return errors;
  }

  isResponseValid(values) {
    const errors = this.getErrors(values);
    return errors.length === 0;
  }

  isStepable(answers) {
    const next = this.getNext(answers);
    if (next.isLast) return 1;

    const maxMotives = get(this, 'metadata.settings.maxMotivos', 1);
    const commentEnabled = get(this, 'metadata.settings.commentEnabled', false);
    const motivesInQuestion = get(this, 'motives', []);
    const hasMotiveWithInput =
      motivesInQuestion.length > 0
        ? motivesInQuestion.reduce(
            (reduced, motive) =>
              reduced +
              (get(motive, 'metadata.settings.showInput', false) ? 1 : 0),
            0
          )
        : null;

    // Stop autoStep on  comments Poll
    const isComments = get(this, 'metadata.settings.commentEnabled', false);
    if (isComments) return 1;

    //find Index
    const index = answers.findIndex(
      (question) => question.questionId === this.id
    );

    if(get(answers[index],'dirty') && !get(answers[index],'score') && this.score_type!==null) return 0;
    const numberOfMotiveSelected = get(
      answers[index],
      'motivoSelected',
      []
    ).length;

    if (numberOfMotiveSelected === maxMotives) {
      const lastMotive =
        answers[index].motivoSelected[numberOfMotiveSelected - 1].id;
      const motiveIndex = this.motives.findIndex(
        (item) => item.id === lastMotive
      );

      if (
        get(
          this,
          `motives[${motiveIndex}].metadata.settings.showInput`,
          false
        ) === false
      ) {
        return 0;
      }
    }

    // Conditions for consider not stepable question
    if (maxMotives > 1 || commentEnabled || hasMotiveWithInput > 0) {
      return 1;
    }
    return 0;
  }

  getGroup() {
    return get(this, 'metadata.settings[group]', false);
  }

  getLayout() {
    return get(this, 'settings[layout]');
  }

  matchId(id) {
    return id === this.id;
  }

  getStyle() {
    return {
      style: {
        fontSize: get(this, 'metadata.settings.fontSize'),
        // color: get(this, "metadata.settings.color", "#262626")
      },
    };
  }

  getDescription() {
    return get(this, 'metadata.settings.description');
  }

  getDescriptionStyle() {
    return {
      style: {
        fontSize: get(
          this,
          'metadata.settings.descriptionSize',
          get(this, 'metadata.settings.fontSize')
        ),
        // color: get(this, "metadata.settings.color", "#262626")
      },
    };
  }

  // random motives
  shuffleArray(a) {
    var notMove = a.filter((e) => get(e, 'metadata.settings.notMove')); //los motivos que no se deben mover
    var lastMotives = a.filter((e) => get(e, 'metadata.settings.lastMotive')); //los motivos que deben quedar al final
    a = a.filter((e) => !lastMotives.includes(e));
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      if (!notMove.includes(a[i])) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
    }
    // agrego los ultimos motivos al array
    lastMotives.forEach((element) => {
      a.push(element);
    });
    return a;
  }

  getQuestions() {
    return [this];
  }
}

/*

1. Fuiste al evento?

2. Fue mucha gente?

3. Fue Caro?

4. Por qué no fuiste?

5. Está lloviendo?

.....
1: No
5:
Termnar

.... Opción goto en última del bloque de Sí al evento
1: Sí
2:
3: goto 5
5
Terminar

.... Opción else
1: Sí
2: goto 4
5
Terminar


*/
